import request from '@/utils/request';
export function fetchMenuList() {
  return request({
    url: '/admin/menu/list',
    method: 'get'
  });
}